import { Box, Button, useTheme } from "@mui/material";
import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import handUp3d from "../../../../../../media/images/icons/handUp3d.png";
import zIndex from "@mui/material/styles/zIndex";

interface Props {
  title: string;
  icon: string;
  path: string;
  bgColor?: string;
  textColor?: string;
  titleBg?: string;
  position: "left" | "right" | "center";
  height?: string;
}

export default function DashboardMenuItem({
  path,
  title,
  icon,
  position,
  bgColor,
  textColor,
  titleBg,
  height = "120px",
}: Props) {
  const theme = useTheme();

  const navigate = useNavigate();

  return (
    <Button
      fullWidth
      onClick={() => navigate(path)}
      sx={{
        padding: "0px",
        // boxShadow: "0px 4px 8px 0px rgba(0, 0, 0, 0.30)",
        flex: "1",
        width: "100%",
        minWidth: 0,

        border: "1px solid gary",
        // backgroundColor:
        //   position === "right" ? theme.palette.primary.main : "#fff",

        borderRadius: "16px",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          width: "100%",
          position: "relative",
          height,
          backgroundColor: bgColor,
          backgroundImage: `
        url(${icon})
        `,
          backgroundRepeat: "no-repeat",
          backgroundSize: "80px",
          backgroundPosition: "50% 30%",
        }}
      >
        <Box
          style={{
            zIndex: "10",
            paddingTop: "8px",
            paddingBottom: "8px",
            borderRadius: "12px",
            position: "absolute",
            bottom: "4px",
            textAlign: "center",
            color: textColor,
            left: "4px",
            right: "4px",
            whiteSpace: "nowrap",
            backgroundColor: titleBg,
          }}
        >
          {title}
        </Box>
      </Box>
    </Button>
  );
}
